import { motion } from "framer-motion";

import ServiceCard from "./ServiceCard";

import { legalServicesData } from "../../../../data/legalServicesData";

const ServicesGrid = () => {
  return (
    <section
      className="
        relative
        overflow-hidden
        bg-[var(--bg-primary)]
        py-6
        sm:py-8
        md:py-10
        lg:py-14
      "
    >
      {/* =====================================================
          BACKGROUND GLOW
      ====================================================== */}

      <div
        className="
          pointer-events-none
          absolute
          -left-32
          top-24
          h-56
          w-56
          rounded-full
          bg-orange-500/[0.05]
          blur-[110px]
          sm:h-72
          sm:w-72
          sm:blur-[130px]
        "
      />

      <div
        className="
          pointer-events-none
          absolute
          -right-32
          bottom-10
          h-56
          w-56
          rounded-full
          bg-orange-500/[0.04]
          blur-[110px]
          sm:h-72
          sm:w-72
          sm:blur-[130px]
        "
      />

      {/* =====================================================
          MAIN CONTAINER
      ====================================================== */}

      <div
        className="
          relative
          mx-auto
          w-full
          max-w-7xl
          px-4
          sm:px-6
          lg:px-8
        "
      >
        {/* =================================================
            SECTION HEADER
        ================================================== */}

        <motion.div
          initial={{
            opacity: 0,
            y: 20,
          }}
          whileInView={{
            opacity: 1,
            y: 0,
          }}
          transition={{
            duration: 0.6,
            ease: "easeOut",
          }}
          viewport={{
            once: true,
            amount: 0.2,
          }}
          className="
            mx-auto
            mb-9
            max-w-5xl
            text-center
            sm:mb-10
            lg:mb-12
          "
        >
          {/* Label */}

          <span
            className="
              inline-flex
              items-center
              rounded-full
              border
              border-orange-500/20
              bg-orange-500/[0.08]
              px-3
              py-1.5
              text-[10px]
              font-semibold
              uppercase
              tracking-[2px]
              text-orange-400
              sm:px-4
              sm:py-2
              sm:text-xs
              sm:tracking-[2.5px]
            "
          >
            Our Legal Services
          </span>

          {/* Heading */}

          <h2
            className="
              mt-4
              text-2xl
              font-bold
              leading-tight
              tracking-tight
              text-[var(--text-primary)]
              sm:mt-5
              sm:text-3xl
              md:text-4xl
              lg:text-5xl
            "
          >
            Complete Legal Solutions{" "}
            <span className="text-orange-500">
              Under One Roof
            </span>
          </h2>

          {/* Description */}

          <p
            className="
              mx-auto
              mt-3
              max-w-7xl
              text-xs
              leading-5
              text-[var(--text-muted)]
              sm:mt-4
              sm:text-sm
              sm:leading-6
              md:text-base
              md:leading-7
            "
          >
            We provide end-to-end legal, taxation, licensing, compliance,
            certification, intellectual property, and documentation services
            for startups, MSMEs, enterprises, NGOs, educational institutions,
            and professionals.
          </p>
        </motion.div>

        {/* =================================================
            SERVICES GRID
        ================================================== */}

        <div
          className="
            grid
            grid-cols-1
            gap-4
            sm:grid-cols-2
            sm:gap-5
            lg:gap-6
            xl:grid-cols-3
          "
        >
          {legalServicesData.map((service, index) => (
            <ServiceCard
              key={service.slug}
              service={service}
              index={index}
            />
          ))}
        </div>
      </div>
    </section>
  );
};

export default ServicesGrid;